import { Reveal } from "../components/Reveal";
import { HOST, PORTRAIT_URL, scrollToId } from "../lib/content";

const Portrait = () => (
  <div className="relative overflow-hidden border border-black/10" style={{ aspectRatio: "4/5" }} data-testid="host-portrait-panel">
    <img
      src={PORTRAIT_URL}
      alt={HOST.name}
      className="absolute inset-0 w-full h-full object-cover"
      data-testid="host-portrait-image"
    />
  </div>
);

export default function HostSection() {
  return (
    <section id="host" className="py-28 md:py-36 px-6 md:px-12" style={{ background: "#FFFFFF" }} data-testid="host-section">
      <div className="max-w-[1300px] mx-auto">
      <Reveal><p className="chapter-label mb-12">[005] — YOUR HOST</p></Reveal>
      <div className="grid lg:grid-cols-[420px_1fr] gap-12 lg:gap-20 items-start">
        <Reveal><Portrait /></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-bold uppercase text-3xl md:text-[42px] leading-[1.05] tracking-tight mb-8">
            Guidance From Someone Who Works Inside the Process.
          </h2>
          <div className="h-px w-24 mb-8" style={{ background: "#7C3AED" }} />
          <div className="space-y-5 text-[15px] leading-[1.8] text-black/55 max-w-xl">
            <p>
              I'm Velisa Johnson, and I spend every day inside the mortgage process — reviewing files, matching programs, and walking first-time buyers in Nevada and Texas through their real numbers. Not estimates. Not guesses. The actual math lenders use.
            </p>
            <p>
              What I've learned is that most first-time buyers don't struggle because they can't qualify. They struggle because nobody ever showed them how qualification actually works — so they rely on myths, big-bank form letters, and advice from people who bought homes in a completely different market.
            </p>
            <p>
              This webinar exists to close that gap. In 45 minutes, you'll see how buying power is calculated, which programs fit W-2, self-employed, and 1099 income, and what to prepare — so whatever you decide next, you decide it informed.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-px mt-10 mb-10 border border-black/10 bg-black/10 max-w-xl" data-testid="host-credentials-grid">
            {[
              ["COMPANY", HOST.company],
              ["NMLS#", HOST.nmls],
              ["CO. NMLS#", HOST.companyNmls],
              ["LICENSED IN", HOST.licenseStates],
            ].map(([label, value]) => (
              <div key={label} className="p-5" style={{ background: "#ffffff" }}>
                <p className="font-mono-c text-[9px] tracking-[0.3em] text-black/35 mb-1.5">{label}</p>
                <p className="text-sm font-semibold text-[#181818]">{value}</p>
              </div>
            ))}
          </div>
          <button onClick={() => scrollToId("register")} className="btn-accent px-8 py-4 text-[13px]" data-testid="host-cta">
            ✓ RESERVE MY FREE SEAT
          </button>
        </Reveal>
      </div>
      </div>
    </section>
  );
}
